import { render, staticRenderFns } from "./bulma_reminder.vue?vue&type=template&id=7e5a3b72&lang=html"
import script from "./bulma_reminder.vue?vue&type=script&lang=js"
export * from "./bulma_reminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports